import i18n from '../../../lib/i18n';
import CarriersConstants from '../../carriers/constants';

export const PATH = `${CarriersConstants.PATH}/branches/details`;
export const PAGE_TITLE = i18n.t('VisualizacaoCompleta');
